import {
  GET_ACTIVE_BLOGS_PENDING,
  GET_ACTIVE_BLOGS_FULFILLED,
  GET_ACTIVE_BLOGS_REJECTED,
  GET_BLOG_BY_SLUG_PENDING,
  GET_BLOG_BY_SLUG_FULFILLED,
  GET_BLOG_BY_SLUG_REJECTED,
  GET_RECENT_BLOGS_PENDING,
  GET_RECENT_BLOGS_FULFILLED,
  GET_RECENT_BLOGS_REJECTED,
} from "../actions/blog";

const initialState = {
  fetching: false,
  blogs: [],
  currentBlog: null,
  recentBlogs: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ACTIVE_BLOGS_PENDING:
      return { ...state, fetching: true };
    case GET_ACTIVE_BLOGS_FULFILLED:
      return { ...state, blogs: action.payload, fetching: false };
    case GET_ACTIVE_BLOGS_REJECTED:
      return { ...state, fetching: false };

    case GET_BLOG_BY_SLUG_PENDING:
      return { ...state, fetching: true, currentBlog: null };
    case GET_BLOG_BY_SLUG_FULFILLED:
      return { ...state, currentBlog: action.payload, fetching: false };
    case GET_BLOG_BY_SLUG_REJECTED:
      return { ...state, fetching: false };

    case GET_RECENT_BLOGS_PENDING:
      return { ...state };
    case GET_RECENT_BLOGS_FULFILLED:
      return { ...state, recentBlogs: action.payload };
    case GET_RECENT_BLOGS_REJECTED:
      return { ...state };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/blogReducer.js